import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { clubsApi } from '../services/api'

export const useClubsStore = defineStore('clubs', () => {
  // State
  const clubs = ref([])
  const loading = ref(false)
  const error = ref(null)

  // Getters
  const isClubsLoaded = computed(() => clubs.value.length > 0)
  const activeClubs = computed(() => clubs.value.filter(club => club.IsActive))

  // Actions
  const fetchClubs = async () => {
    try {
      loading.value = true
      error.value = null
      
      const response = await clubsApi.getAll()
      clubs.value = response.data.data
    } catch (err) {
      console.error('Error fetching clubs:', err)
      error.value = err.response?.data?.error || 'Failed to fetch clubs'
      throw err
    } finally {
      loading.value = false
    }
  }

  const createClub = async (clubData) => {
    try {
      loading.value = true
      error.value = null
      
      const response = await clubsApi.create(clubData)
      await fetchClubs() // Refresh the list
      return response.data
    } catch (err) {
      console.error('Error creating club:', err)
      error.value = err.response?.data?.error || 'Failed to create club'
      throw err
    } finally {
      loading.value = false
    }
  }

  const updateClub = async (id, clubData) => {
    try {
      loading.value = true
      error.value = null
      
      const response = await clubsApi.update(id, clubData)
      await fetchClubs() // Refresh the list
      return response.data
    } catch (err) {
      console.error('Error updating club:', err)
      error.value = err.response?.data?.error || 'Failed to update club'
      throw err
    } finally {
      loading.value = false
    }
  }

  const deleteClub = async (id) => {
    try {
      loading.value = true
      error.value = null
      
      const response = await clubsApi.delete(id)
      await fetchClubs() // Refresh the list
      return response.data
    } catch (err) {
      console.error('Error deleting club:', err)
      error.value = err.response?.data?.error || 'Failed to delete club'
      throw err
    } finally {
      loading.value = false
    }
  }

  const clearClubs = () => {
    clubs.value = []
    error.value = null
  }

  return {
    // State
    clubs,
    loading,
    error,
    
    // Getters
    isClubsLoaded,
    activeClubs,
    
    // Actions
    fetchClubs,
    createClub,
    updateClub,
    deleteClub,
    clearClubs
  }
}) 